import { doc, getDocFromServer } from 'firebase/firestore';
import { db } from '../../firebase-client';

const TEAM_READY_TIMEOUT_MS = 10000;
const TEAM_READY_POLL_MS = 400;

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function waitForTeamToExist(teamId) {
  const startedAt = Date.now();
  const teamRef = doc(db, 'teams', teamId);

  while (Date.now() - startedAt < TEAM_READY_TIMEOUT_MS) {
    const snap = await getDocFromServer(teamRef);
    if (snap.exists()) return;
    await wait(TEAM_READY_POLL_MS);
  }

  throw new Error('Created team was not readable before navigation.');
}
